export default __webpack_public_path__ + "static/media/dots-triple.a076f6e6.svg";